<template>
  <Modal
    :value="value"
    @hide="hide()"
    title="Computer Agent"
    :subtitle="`Download installer for ${domain.friendlyName}`"
  >
    <template slot="body" class="content">
      <p>Please choose an expire date for the installer:</p>
      <DatePicker
        type="date"
        :startDate="date"
        :minDate="new Date()"
        @selected="date = $event"
      ></DatePicker>

      <div class="notification content is-primary is-light">
        Install the Agent on the computers that you want to be in this domain.
        They will appear under <i>Computers</i> when the installation is
        complete.

        <br />
        <br />
        This installer is only for this domain ({{ domain.friendlyName }}). Each
        domain has its own installer.
      </div>

      <div class="notification content is-warning is-light">
        All other installers for this domain will expire when downloading a new
        installer.
        <a v-if="!showMore" @click.stop="showMore = true">More information...</a>
      </div>

      <transition
        name="custom-classes-transition"
        enter-active-class="pulse-fast-once"
        appear
      >
        <div v-if="showMore" class="notification fade-in-once margin-bottom-10">
          <button @click.stop="showMore = false" class="delete"></button>

          An expired installer will still install the Agent, but it will not be
          able to pair the computer with the domain and connect to the server.
          Though, an expired installer has no affect on an already paired
          computer.
        </div>
      </transition>
    </template>
    <template slot="footer" class="content">
      <div v-if="!isLoading">
        <div
          @click="download()"
          class="button is-success"
          :class="{ 'is-loading': isLoading }"
        >
          Download
        </div>
        <div class="button" @click="hide()">Cancel</div>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
import { focus, getId, downloadFile } from "@/utils/document";

import { postApi } from "@/utils/http";
import { appBaseUrl } from "@/utils/settings";

export default {
  props: {
    value: Boolean,
    title: String,
    domain: Object,
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue"),
    DatePicker: () => import("@/components/singles/DatePicker.vue"),
  },
  data() {
    return {
      date: new Date(),
      isLoading: false,
      showMore: false,
    };
  },

  async created() {
    this.date = new Date(this.date.setDate(this.date.getDate() + 7));
  },
  methods: {
    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    },
    async download() {
      this.isLoading = true;
      this.$helpers.notify("Installer", "Creating key.");
      await postApi("create/pairingKey", {
        domainUID: this.domain.uid,
        validUntil: this.date,
      });

      this.$helpers.notify("Installer", "Creating MSI package.");

      try {
        const msiPackageUrl = await postApi("msiPackage", {
          domainUID: this.domain.uid,
        });

        this.$helpers.notify("Installer", "Starting download.");
        downloadFile(`${appBaseUrl}/${msiPackageUrl}`);
        this.$emit("success");
      } catch (err) {
        if (err.response.status === 410)
          this.$helpers.notify("Error", "No key is created.", "danger", -1);
        else if (err.response.status === 500)
          this.$helpers.notify(
            "Error",
            "Failed to create MSI package.",
            "danger"
          );
      }

      this.isLoading = false;      
      this.hide();
    },
  },
};
</script>
